<template lang="pug">
  div
    modal-share-tracker(ref="modal" :token="token")
    .btn.btn-secondary.btn-block(@click="showModal")
      icon.mr-4(icon="fa-solid fa-arrow-up-from-bracket" )
      span {{ $t('order.share_tracker.button') }}
</template>
<script>
import ModalShareTracker from '@/components/organism/modal/ModalShareTracker.vue'
import { OrderShare } from '@/api'

const orderShare = new OrderShare()

export default {
    components: { ModalShareTracker },
    data() {
        return {
            token: null,
        }
    },
    methods: {
        async showModal() {
            const response = await orderShare.fetch(`${this.$route.params.id}`)
            this.token = response.token
            this.$refs.modal.openModal()
        },
    },
}
</script>
